import React, { ReactElement } from "react";
import {cloneElement} from "react";
import {XBigButton} from './XBigButton';
//import {XIterableElement} from './XIterableElement';

import styles from './styles/XButtonsLine.module.scss';
//import { getNameOfDeclaration } from "typescript";


export interface IButtonsLineProps {
    class?: string | null;
    //children? : (XButton | Iterable<XButton>) & React.ReactNode;// React.ReactElement<XButton> | Iterable<React.ReactElement<XButton>>;
    children? : (React.ReactElement<XBigButton> | Iterable<React.ReactElement<XBigButton>>) & React.ReactNode;
    height? : string | null;
    width? : string | null;
    flexGrow? : number | null;
    //name:string;
    //optionalParam?:number;
}
export interface IButtonsLineState {

}
export class XButtonsLine extends React.Component<IButtonsLineProps, IButtonsLineState> {

    public constructor(props: IButtonsLineProps) {
        super(props);
    }
    render() : React.ReactNode
    {
        const items = React.Children.toArray(this.props.children);
        return (
            <div className={styles.XButtonsLine} >
                {React.Children.map(items, (item, i) => {
                        const isLast = (items.length - 1) === i;
                        let xButton = item as unknown as XBigButton
                        if(!!xButton)
                            if(xButton.props.isActive)
                            {
                                let result = cloneElement(item as ReactElement<any>, {className: styles.Active});
                                return (<>{result}{(!isLast) && <div/>}</>);
                            }    
                        return (<>{item}{(!isLast) && <div/>}</>);
                })}
           </div>
        );
    }
}